import { useEffect } from 'react';

interface SchemaOrgProps {
  type: 'LodgingBusiness' | 'FAQPage' | 'WebPage';
  data: Record<string, unknown>;
}

export function useSchemaOrg({ type, data }: SchemaOrgProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = `schema-${type}`;
    
    let schemaData = {};
    
    if (type === 'LodgingBusiness') {
      schemaData = {
        '@context': 'https://schema.org',
        '@type': 'LodgingBusiness',
        name: 'あさぎり荘',
        image: `${import.meta.env.VITE_SITE_URL || 'https://asagiriso.com'}/og-image.jpg`,
        '@id': import.meta.env.VITE_SITE_URL || 'https://asagiriso.com',
        url: import.meta.env.VITE_SITE_URL || 'https://asagiriso.com',
        telephone: '+81-79-667-8119',
        priceRange: '¥¥',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'ハチ高原',
          addressLocality: '養父市',
          addressRegion: '兵庫県',
          postalCode: '667-0000',
          addressCountry: 'JP',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 35.3833,
          longitude: 134.6833,
        },
        openingHoursSpecification: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: [
              'Monday',
              'Tuesday',
              'Wednesday',
              'Thursday',
              'Friday',
              'Saturday',
              'Sunday',
            ],
            opens: '15:00',
            closes: '19:00',
          },
        ],
        amenityFeature: [
          {
            '@type': 'LocationFeatureSpecification',
            name: '体育館',
            value: true,
          },
          {
            '@type': 'LocationFeatureSpecification',
            name: 'スキー場アクセス',
            value: true,
          },
        ],
        ...data,
      };
    } else if (type === 'FAQPage') {
      schemaData = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        ...data,
      };
    } else if (type === 'WebPage') {
      schemaData = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'あさぎり荘',
        url: import.meta.env.VITE_SITE_URL || 'https://asagiriso.com',
        ...data,
      };
    }
    
    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);
    
    return () => {
      const existingScript = document.getElementById(`schema-${type}`);
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, [type, data]);
}
